import N8nInfoAccordion from './InfoAccordion.vue';

export default N8nInfoAccordion;
export type { IAccordionItem } from './InfoAccordion.vue';
